import Vue from "vue";
import Router from "vue-router";
Vue.use(Router)


let router = new Router({
	// mode: 'history',
	routes: [{
			path: '/',
			name: 'index',
			component: () => import('views/01zhihuichengshi.vue')
		},
		{
			path: '/04zhihuiwenlv',
			name: '智慧文旅',
			component: () => import('views/04zhihuiwenlv.vue')
		},
		// {
		// 	path: '/03zhihuisuyuan',
		// 	name: '智慧溯源',
		// 	component: () => import('views/03zhihuisuyuan.vue')
		// },
		// {
		// 	path: '/15zhihuichengguan',
		// 	name: '智慧城管',
		// 	component: () => import('views/15zhihuichengguan.vue')
		// },
		{
			path: '/01zhihuichengshi',
			name: '智慧城市',
			component: () => import('views/01zhihuichengshi.vue')
		},

		{
			path: '/02shuzixiangcun',
			name: '数字乡村',
			component: () => import('views/02shuzixiangcun.vue')
		},

		// {
		// 	path: '/11zhihuijiaotong',
		// 	name: '智慧交通',
		// 	component: () => import('views/11zhihuijiaotong.vue')
		// },
		{
			path: '/12zhihuijiaoyu',
			name: '智慧教育医疗',
			component: () => import('views/12zhihuijiaoyu.vue')
		},

		{
			path: '/16zhihuidangjian',
			name: '智慧党建',
			component: () => import('views/16zhihuidangjian.vue')
		},
		{
			path: '/17zhihuizhengwu',
			name: '智慧政务',
			component: () => import('views/17zhihuizhengwu.vue')
		},
		// {
		// 	path: '/18zongheguanli',
		// 	name: '综合管理平台',
		// 	component: () => import('views/18zongheguanli.vue')
		// },
		// {
		// 	path: '/19xiangxianwenhua',
		// 	name: '乡贤文化',
		// 	component: () => import('views/19xiangxianwenhua.vue')
		// },
		{
			path: '/05huanghuacai',
			name: '黄花菜展示中心',
			component: () => import('views/05huanghuacai.vue')
		},
		{
			path: '/11zhihuijiaotong',
			name: '智慧交通',
			component: () => import('views/11zhihuijiaotong.vue')
		},
		{
			path: '/20welcomQi',
			name: '祁东欢迎页',
			component: () => import('views/20welcomQi.vue')
		},
		// {
		// 	path: '/21xuanchuanshipin',
		// 	name: '宣传视频',
		// 	component: () => import('views/21xuanchuanshipin.vue')
		// },
		{
			path: '/22qidongye',
			name: '启动页',
			component: () => import('views/22qidongye.vue')
		},
		{
			path: '/23qidongshipin',
			name: '启动视频',
			component: () => import('views/23qidongshipin.vue')
		},
		{
			path: '/24welHeader',
			name: '欢迎市领导',
			component: () => import('views/24welHeader.vue')
		},
		{
			path: '/25huanghuaqing',
			name: '黄花情',
			component: () => import('views/25huanghuaqing.vue')
		},
		{
			path: '/26huanghuacai',
			name: '黄花菜',
			component: () => import('views/26huanghuacai.vue')
		},
		{
			path: '/27fazhangaikuang',
			name: '发展概况',
			component: () => import('views/27fazhangaikuang.vue')
		},
		{
			path: '/28shajingwan',
			name: '沙井湾',
			component: () => import('views/28shajingwan.vue')
		},
		{
			path: '/29threehuanghuacai',
			name: '黄花菜三分钟角标版',
			component: () => import('views/29threehuanghuacai.vue')
		},
		{
			path: '/qidonghuangyiyes',
			name: 'new欢迎页',
			component: () => import('views/qidonghuangyiyes.vue')
		},
		{
			path: '/30carInc',
			name: '介绍页',
			component: () => import('views/30carInc.vue')
		},
		{
			path: '/31gongyinliang',
			name: '祁东供应链后台',
			component: () => import('views/31gongyinliang.vue')
		},
		{
			path: '/tyPage',
			name: '公共视频页面',
			component: () => import('views/tyPage.vue')
		},
		{
			path: '/41huafeng',
			name: '桦峰传媒',
			component: () => import('views/41huafeng.vue')
		},
		{
			path: '/42guanying',
			name: '光影计划',
			component: () => import('views/42guanying.vue')
		},
		{
			path: '/43huanhualian',
			name: '黄花之恋',
			component: () => import('views/43huanhualian.vue')
		},
		{
			path: '/44daotianyishu',
			name: '稻田艺术',
			component: () => import('views/44daotianyishu.vue')
		},
		{
			path: '/45zhongdaochanwu',
			name: '中道禅舞',
			component: () => import('views/45zhongdaochanwu.vue')
		},
		{
			path: '/46ronshuxinyuan',
			name: '榕树心愿',
			component: () => import('views/46ronshuxinyuan.vue')
		},
		{
			path: '/47cailizhi',
			name: '采荔枝',
			component: () => import('views/47cailizhi.vue')
		},
		{
			path: '/48zhcs',
			name: '数字城市',
			component: () => import('views/48zhcs.vue')
		},
		{
			path: '/49zhjt',
			name: '数字交通',
			component: () => import('views/49zhjt.vue')
		},
		{
			path: '/50zhzg',
			name: '数字展馆',
			component: () => import('views/50zhzg.vue')
		},
		{
			path: '/51zhjq',
			name: '数字景区',
			component: () => import('views/51zhjq.vue')
		},
		{
			path: '/52zhdl',
			name: '数字电力',
			component: () => import('views/52zhdl.vue')
		},
		{
			path: '/53zhly',
			name: '数字楼宇',
			component: () => import('views/53zhly.vue')
		},
		{
			path: '/54zhsq',
			name: '数字社区',
			component: () => import('views/54zhsq.vue')
		},
		{
			path: '/55zhsw',
			name: '数字水务',
			component: () => import('views/55zhsw.vue')
		},
		{
			path: '/56xhvideo',
			name: '新亨宣传',
			component: () => import('views/56xinghengvideo.vue')
		},
		{
			path: '/57byvideo',
			name: '报业宣传片',
			component: () => import('views/57baoyevideo.vue')
		},
		{
			path: '/58byvideo',
			name: '报业宣传片2',
			component: () => import('views/58baoyevideo2.vue')
		},
		{
			path: '/59byvideo',
			name: '报业宣传片3',
			component: () => import('views/59baoyevideo3.vue')
		},
		{
			path: '/60qytea',
			name: 'qytea',
			component: () => import('views/60qytea.vue')
		},
		{
			path: '/61qymi',
			name: 'qymi',
			component: () => import('views/61qymi.vue')
		},
		{
			path: '/62qyshun',
			name: 'qyshun',
			component: () => import('views/62qyshun.vue')
		},
		{
			path: '/63qycaixin',
			name: 'qycaixin',
			component: () => import('views/63qycaixin.vue')
		},
		{
			path: '/64qyji',
			name: 'qyji',
			component: () => import('views/64qyji.vue')
		},
		{
			path: '/65qyvideo',
			name: 'qyvideo',
			component: () => import('views/65qyvideo.vue')
		},
		{
			path: '/66byvideo',
			name: 'byvideo',
			component: () => import('views/66byvideo.vue')
		},
		// {
		// 	path: '/20welcomSheng',
		// 	name: '报业揭阳欢迎页',
		// 	component: () => import('views/20welcomSheng.vue')
		// },
		// {
		// 	path: '/map',
		// 	name: 'map',
		// 	component: () => import('views/map.vue')
		// },
		// {
		// 	path: '/test',
		// 	name: 'test',
		// 	component: () => import('views/test.vue')
		// },
	]
})
export default router;
